<template>
    <div class="mb-4">
        <template v-for="(item, key) in items">
            <v-checkbox :label="item.answer" :value="key" :class="{'font-weight-black': item.font === '1'}"  :key="key" hide-details v-model="selected" color="green" class="mt-0 pt-0 mb-4"></v-checkbox>
            <img :src="`${API_URL}/storage/answers/${item.image}`" v-if="item.image" width="150">
        </template>
    </div>
</template>

<script>
    export default {
        props: ['items'],
        data(){
            return {
                selected: []
            }
        },

        watch: {
            selected: function (newVal) {
                this.$emit('change', newVal);
            }
        }
    }
</script>